module.exports = __webpack_public_path__ + "static/media/speakers_logos_AWS.4b17fbd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_AWS.jpg
// module id = 262
// module chunks = 0